import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const pill = "rounded-full border border-[#D4AF37]/40 px-3 py-1.5 text-[#F3E5AB] hover:bg-[#D4AF37] hover:text-[#0B0907] transition-colors";

export function Header() {
  const { count, setOpen } = useCart();
  return (
    <header className="fixed top-4 inset-x-0 z-50 px-3 sm:px-4" data-testid="site-header">
      <nav className="mx-auto max-w-6xl flex items-center justify-between gap-2 rounded-full border border-[#D4AF37]/20 bg-[#14110E]/70 backdrop-blur-xl px-4 sm:px-5 py-2.5">
        <Link to="/home" className="font-display font-semibold text-sm sm:text-base tracking-[0.25em] text-[#F3E5AB] shrink-0" data-testid="nav-logo">
          <span className="hidden lg:inline">ANCIENT ORIGIN</span><span className="lg:hidden">AO</span>
        </Link>
        <div className="flex items-center gap-2.5 sm:gap-6 text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#A89F91]">
          <Link to="/store" className="hover:text-[#F3E5AB] transition-colors" data-testid="nav-store">Store</Link>
          <a href="/home#origins" className="hidden md:inline hover:text-[#F3E5AB] transition-colors" data-testid="nav-origins">Origins</a>
          <a href="/home#about" className="hidden md:inline hover:text-[#F3E5AB] transition-colors" data-testid="nav-about">Our Story</a>
          <Link to="/login" className="hidden sm:inline hover:text-[#F3E5AB] transition-colors" data-testid="nav-portal">Portal</Link>
          <Link to="/admin" className={pill} data-testid="nav-admin-button">Admin</Link>
          <Link to="/manufacturer" className={pill} data-testid="nav-manufacturer-button">Manufacturer</Link>
          <button onClick={() => setOpen(true)} className="relative text-[#F3E5AB] ml-1" data-testid="cart-drawer-toggle" aria-label="Open cart">
            <ShoppingBag className="h-5 w-5" strokeWidth={1.4} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2.5 h-4 min-w-4 px-1 rounded-full bg-[#8B1E1E] text-[10px] text-white grid place-items-center" data-testid="cart-count">
                {count}
              </span>
            )}
          </button>
        </div>
      </nav>
    </header>
  );
}
